import {useVisualizerSession} from "../../visualizer/VscVisualizerSession";
import IVscCommunityMapInfo from "../../../visualizers/IVscCommunityMapInfo";
import {useState} from "react";
import AdminMapInfo from "./AdminMapInfo";

import {IViewItemConfig} from "../../../data/IViewpoint";

export interface IFindYourHomeAdmin {
    activeCamera?: string,
    viewItems: IViewItemConfig[]
}


const FindYourHomeAdmin: React.FC<IFindYourHomeAdmin> = (props) => {


    const screenprops = [
        ["Active Camera", props.activeCamera ?? "none"]
    ];
    const visualizerSession = useVisualizerSession();

    const [mapInfo, setMapInfo] = useState<IVscCommunityMapInfo | null>(null);
    const loadMapInfo = async () => {
        const mapInfoResponse = await visualizerSession.requestMapInfo();
        setMapInfo(mapInfoResponse);
    }

    return <main>
        <h1>Vsc Admin / Find your home</h1>

        <table>
            <tr>
                <th>Property</th>
                <th>Value</th>
            </tr>
            {screenprops.map((prop) => <tr>
                <td>{prop[0]}</td>
                <td>{prop[1]}</td>
            </tr>)
            }
        </table>

        <button onClick={() => loadMapInfo()}>Load map info</button>
        {mapInfo && <AdminMapInfo mapInfo={mapInfo} viewItems={props.viewItems}/>}
    </main>

}
export default FindYourHomeAdmin;